import styled from 'styled-components';

export const PromotionContentWrapper = styled.div`
  ${props => props.css};
`;

export const SectionsWrapper = styled.div`
  text-align: center;
  padding: 34px 10px;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    padding: 54px 50px;
  }

  ${props => props.css};
`;

export const HeaderTagLine = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 400;
  color: ${props => props.theme.carvana.blue.dark};
  line-height: 23px;
  text-transform: uppercase;
  width: 100%;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    font-size: 22px;
  }

  ${props => props.css};
`;

export const HeaderHero = styled.h2`
  font-size: 28px;
  font-weight: 700;
  width: 100%;
  margin: 0;
  line-height: 35px;
  letter-spacing: 0px;
  color: ${props => props.theme.carvana.blue.dark};
  text-transform: uppercase;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    font-size: 40px;
  }

  ${props => props.css};
`;

export const SubHeader = styled.h4`
  font-size: 16px;
  font-weight: 300;
  width: 100%;
  color: black;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    font-size: 18px;
  }

  ${props => props.css};
`;

export const VideoWrapper = styled.div`
  height: 200px;
  width: 300px;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    height: 300px;
    width: 500px;
  }

  ${props => props.css};
`;

export const Image = styled.img`
  &.mobile {
    display: block;

    @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
      display: none;
    }
  }

  &.tablet {
    display: none;

    @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
      display: block;
    }

    @media (min-width: ${props => props.theme.breakpoints.values.lg}px) {
      display: none;
    }
  }

  &.desktop {
    display: none;

    @media (min-width: ${props => props.theme.breakpoints.values.lg}px) {
      display: block;
    }
  }

  ${props => props.css};
`;

export const Body = styled.div`
  p {
    font-size: 16px;
    line-height: 24px;
    color: ${props => props.theme.carvana.blue.dark};

    a {
      text-decoration: underline;
      color: ${props => props.theme.carvana.blue.primary};
    }

    a:hover {
      text-decoration: underline;
      color: ${props => props.theme.carvana.blue.hover};
    }

    ${props => props.cssOverrides};      
  }
`;

export const Button = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 56px;
  height: 50px;
  min-width: 310px;
  border-radius: 3px;
  box-shadow: none;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
  text-transform: uppercase;
  transition: background-color 200ms, color 200ms;

  background-color: ${props => props.theme.carvana.blue.primary};
  border: 1px solid ${props => props.theme.carvana.blue.primary};
  color: ${props => props.theme.carvana.white.primary};

  &:hover {
    background-color: ${props => props.theme.carvana.blue.hover};
    border: 1px solid ${props => props.theme.carvana.blue.hover};
    color: ${props => props.theme.carvana.white.primary};
    cursor: pointer;
    text-decoration: none;
  }

  ${props => props.css};
`;

export const Link = styled.a`
  color: ${props => props.theme.carvana.blue.primary};
  font-size: 17px;
  font-weight: 300;

  &:hover {
    color: ${props => props.theme.carvana.blue.hover};
    text-decoration: none;
  }

  ${props => props.css};
`;

export const CalloutWrapper = styled.div`
  display: flex;
  width: 100%;
  text-align: left;

  ${props => props.css};
`;

export const CalloutInfoWrapper = styled.div`
  flex: 1;
  margin-left: 20px;
`;

export const CalloutTitle = styled.p`
  font-size: 16px;
  font-weight: 700;
  color: ${props => props.theme.carvana.blue.dark};
  margin: 0;

  ${props => props.css};
`;

export const CalloutInfo = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: ${props => props.theme.carvana.gray.dark};
  margin: 0;

  ${props => props.css};
`;

export const FootnoteWrapper = styled.div`
  height: 100%;
  width: 100%;
  background-color: ${props => props.theme.carvana.gray.background};

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    height: auto;
  }

  ${props => props.css};
`;

export const FootnoteContent = styled.p`
  max-width: 525px;
  padding: 40px 30px;
  margin: 0 auto;
  text-align: left;
  font-size: 14px;
  font-weight: 400;
  color: ${props => props.theme.carvana.gray.dark};

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    max-width: 525px;
    padding: 35px 0;
    font-size: 12px;
    line-height: 18px;
  }

  ${props => props.css};
`;

export const FootnoteLink = styled.a`
  color: ${props => props.theme.carvana.blue.primary};
  &:hover, &:visited, &:active {
    color: ${props => props.theme.carvana.blue.primary};
  }

  ${props => props.css};
`;
